import styled from 'styled-components';

import ButtonLink from '../interface/ButtonLink';

export const CtaButton = styled(ButtonLink)`
  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 100%;
    text-align: center;
  }
`;

export const CtaButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-top: 7.5rem;
  }
`;

export const Title = styled.h3`
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-regular);
  font-size: 3.2rem;

  @media (${({ theme }) => theme.respondTo.desktop}) {
    font-size: 3.8rem;
    max-width: 53rem;
    text-align: center;
  }
`;

export const TitleWrapper = styled.div`
  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: flex;
    justify-content: center;
  }
`;

export const UspItem = styled.div`
  @media (${({ theme }) => theme.respondTo.mobile}) {
    margin-top: 5.5rem;
  }
`;

export const UspItemIconWrapper = styled.div`
  color: var(--color-primary);
  height: 4rem;
  margin-bottom: 3rem;

  * {
    height: 100%;
  }
`;

export const UspItemText = styled.p`
  padding-right: 6.5rem;
  margin-top: 2rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-right: 3rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    padding-right: 6.5rem;
  }
`;

export const UspItemTitle = styled.h4`
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-lg);
`;

export const UspWrapper = styled.div`
  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: ${({ uspCount }) => (uspCount > 3 ? '1rem' : '10rem')};

    ${UspItem} {
      flex: ${({ uspCount }) => (uspCount > 3 ? '50%' : '0 0 calc(100% / 3)')};
      margin-top: ${({ uspCount }) => (uspCount > 3 ? '9rem' : '0')};
    }
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    ${UspItemText} {
      padding-right: ${({ uspCount }) => (uspCount > 3 ? '8rem' : '6.5rem')};
    }
  }
`;
